import { PERIOD_PRESETS, type PeriodPreset } from '@/features/analytics/period';

/** Paramètres d'URL communs aux pages Analytics : période, bornes, comparaison, point de vente. */
export interface InsightsSearch {
  period?: PeriodPreset;
  from?: string;
  to?: string;
  compare?: boolean;
  outletId?: string;
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function validateInsightsSearch(search: Record<string, unknown>): InsightsSearch {
  return {
    ...(PERIOD_PRESETS.includes(search['period'] as PeriodPreset)
      ? { period: search['period'] as PeriodPreset }
      : {}),
    ...(typeof search['from'] === 'string' && ISO_DATE.test(search['from'])
      ? { from: search['from'] }
      : {}),
    ...(typeof search['to'] === 'string' && ISO_DATE.test(search['to'])
      ? { to: search['to'] }
      : {}),
    ...(search['compare'] === true || search['compare'] === 'true' ? { compare: true } : {}),
    ...(typeof search['outletId'] === 'string' && UUID.test(search['outletId'])
      ? { outletId: search['outletId'] }
      : {}),
  };
}
